// src/pages/WebsiteCare.tsx

import React from 'react';
import { Link } from 'react-router-dom';

import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";

import GetInTouch from '../components/GetInTouch';


import { useImageParallax } from "../hooks/useImageParallax";

import website from '../assets/images/services/website.webp';

const WebsiteCare: React.FC = () => {


const seo = seoConfig.websiteCare; // ✅ Load meta for this page

useImageParallax(".anim-image-parallax"); // hook call





  return (



<>

      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />



  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-website bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">Website Care</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}


  {/* rts about area three */}
  <div
    className="rts-about-area parallax-about pt_sm--0 pb--80"
    id="about"
  >
    <div className="container">
      <div className="row g-5 align-items-center">
        <div className="col-lg-5">
          <a href="about.html" className="pli-image-link">
            <div className="pli-image-holder">
              {/* Use class "cover-opacity-*" to set image overlay if needed. For example "cover-opacity-2". Useful if class "pli-info-overlay" is enabled on "portfolio-list". Note: It is individual and depends on the image you use. More info about helper classes in file "helper.css". */}
              <figure className="pli-image">
                <img
                  className="anim-image-parallax tt-lazy"
                  src={website}
                  data-src={website}
                  alt="image"
                />
              </figure>{" "}
              {/* /.pli-image */}
            </div>{" "}
            {/* /.pli-image-holder */}
          </a>{" "}
          {/* /.pli-image-link */}
        </div>
        <div className="col-lg-7">

  <div className="content-wrapper">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
     Reliable Website Care You Can Trust
    </h2>
    <p className="disc">
      Running a website doesn’t end after it goes live - it requires regular maintenance, security checks, and performance optimization to ensure it continues working smoothly. At Manikarn Digital, our Website Care services are designed to keep your site secure, updated, and performing at its best.
    </p>
    <Link to="/contact" className="learn-more-btn mt--30">
      Contact Us <i className="fa-solid fa-arrow-up-right-from-square"></i>
    </Link>
  </div>


        </div>
      </div>
    </div>
  </div>
  {/* rts about area three end */}


    {/* service area start */}
  <div className="rts-servicearea-start pt_sm--0 pb--100 pb_sm--20">
    <div className="container">
      <div className="row mb--10">
        <div className="col-lg-12 mx-auto">

  <div className="content-wrapper text-center">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Everything Your Website Needs
    </h2>
  </div>


        </div>
      </div>
      <div className="row g-2">
        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 60 60" fill="none">
  <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none">

    <path d="M30 8 L46 14 V26c0 10-7 18-16 22C21 44 14 36 14 26V14Z"
          stroke-dasharray="170" stroke-dashoffset="170">
      <animate attributeName="stroke-dashoffset" values="170;0;170" dur="4s" repeatCount="indefinite"/>
    </path>


    <rect x="23" y="26" width="14" height="12" rx="2"/>

    <path d="M26 26 v-3a4 4 0 0 1 8 0v3"/>


    <circle cx="30" cy="32" r="2" fill="currentColor" opacity="0.9">
      <animate attributeName="r" values="2;6;2" dur="1.6s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="0.9;0.2;0.9" dur="1.6s" repeatCount="indefinite"/>
    </circle>
  </g>
</svg>




            </div>
            <h5 className="title-1">
              Security You Can Rely On
            </h5>
            <p className="disc">
              Cyber threats are on the rise, and protecting your website is more important than ever. We implement advanced security protocols, regular malware scans, and daily backups so your business data and customer information remain safe.
            </p>
          </div>
          {/* single service area end */}
        </div>


        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 60 60" fill="none">
  <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none">

    <path d="M12 30a18 18 0 1 1 36 0" />
    <rect x="8" y="30" width="8" height="12" rx="2" />
    <rect x="44" y="30" width="8" height="12" rx="2" />
    <path d="M44 42 q4 0 4 4 v2" />
    <circle cx="30" cy="28" r="10" stroke-dasharray="160" stroke-dashoffset="160">
      <animate attributeName="stroke-dashoffset" values="160;0;160" dur="4.2s" repeatCount="indefinite"/>
    </circle>


    <g transform="translate(30 28)">
      <circle r="3" />
      <g>
        <line x1="6" y1="0" x2="9" y2="0" />
        <line x1="-6" y1="0" x2="-9" y2="0" />
        <line x1="0" y1="6" x2="0" y2="9" />
        <line x1="0" y1="-6" x2="0" y2="-9" />
        <line x1="4.2" y1="4.2" x2="6.3" y2="6.3" />
        <line x1="-4.2" y1="4.2" x2="-6.3" y2="6.3" />
        <line x1="4.2" y1="-4.2" x2="6.3" y2="-6.3" />
        <line x1="-4.2" y1="-4.2" x2="-6.3" y2="-6.3" />
      </g>
      <animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" dur="4s" repeatCount="indefinite"/>
    </g>


    <circle cx="48" cy="44" r="2.6" fill="currentColor">
      <animate attributeName="r" values="2.6;4;2.6" dur="1.2s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="1;0.4;1" dur="1.2s" repeatCount="indefinite"/>
    </circle>
  </g>
</svg>






            </div>
            <h5 className="title-1">
              Dedicated Ongoing Support
            </h5>
            <p className="disc">
              With our Website Care plans, you get 24/7 support from experienced professionals. From fixing bugs and updating integrations to troubleshooting errors, we’ve got you covered - so you can focus on growing your business while we handle the technical side.
            </p>

          </div>
          {/* single service area end */}
        </div>



        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 60 60" fill="none">
  <g stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" fill="none">

    <path d="M12 36 a18 18 0 0 1 36 0" />

    <line x1="18" y1="34" x2="20" y2="32"/>
    <line x1="24" y1="30" x2="26" y2="28"/>
    <line x1="30" y1="28" x2="30" y2="26"/>
    <line x1="36" y1="30" x2="34" y2="28"/>
    <line x1="42" y1="34" x2="40" y2="32"/>


    <g transform="translate(30 36)">
      <line x1="0" y1="0" x2="12" y2="0"/>
      <circle r="2" fill="currentColor"/>
      <animateTransform attributeName="transform" type="rotate"
        values="-70 0 0; 70 0 0; -70 0 0" dur="2.6s" repeatCount="indefinite"/>
    </g>


    <g>
      <rect x="18" y="40" width="6" height="10" rx="1"/>
      <rect x="28" y="40" width="6" height="10" rx="1">
        <animate attributeName="height" values="10;16;10" dur="1.8s" repeatCount="indefinite"/>
        <animate attributeName="y" values="40;34;40" dur="1.8s" repeatCount="indefinite"/>
      </rect>
      <rect x="38" y="40" width="6" height="10" rx="1">
        <animate attributeName="height" values="10;20;10" dur="1.8s" begin="0.3s" repeatCount="indefinite"/>
        <animate attributeName="y" values="40;30;40" dur="1.8s" begin="0.3s" repeatCount="indefinite"/>
      </rect>
    </g>
  </g>
</svg>






            </div>
            <h5 className="title-1">
              Performance & Speed Optimization
            </h5>
            <p className="disc">
              A slow website can seriously hurt your traffic and search engine rankings. Our experts continuously monitor and optimize your site’s performance, ensuring faster load times and a seamless browsing experience across all devices.
            </p>

          </div>
          {/* single service area end */}
        </div>






      </div>
    </div>
  </div>
  {/* service area ends */}







{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  




</>


  );
};

export default WebsiteCare;
